import type { TrendPoint } from "@/hooks/useMotivation";

interface Props {
  trend: TrendPoint[];
  loading: boolean;
}

export default function ExamTrendChart({ trend, loading }: Props) {
  if (loading) {
    return (
      <div className="rounded-lg border border-background-200 bg-background-50 p-5 h-full">
        <h3 className="font-heading font-semibold text-base text-foreground-950">Deneme Gelişimi</h3>
        <div className="mt-6 h-40 rounded-md bg-background-100 animate-pulse" />
      </div>
    );
  }

  if (trend.length === 0) {
    return (
      <div className="rounded-lg border border-background-200 bg-background-50 p-5 h-full flex flex-col items-center justify-center text-center">
        <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
          <i className="ri-line-chart-line text-2xl" aria-hidden="true"></i>
        </span>
        <h3 className="mt-3 font-heading font-semibold text-base text-foreground-950">Deneme Gelişimi</h3>
        <p className="mt-1 text-sm text-foreground-600">
          Henüz deneme sınavı çözmedin. İlk denemeni çözünce gelişimin burada görünecek.
        </p>
      </div>
    );
  }

  const maxNet = Math.max(...trend.map((t) => t.net), 1);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5 h-full">
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold text-base text-foreground-950">Deneme Gelişimi</h3>
        <span className="text-xs text-foreground-500">net</span>
      </div>

      <div className="mt-6 flex items-end gap-2 md:gap-3 min-h-40">
        {trend.map((t, i) => (
          <div key={i} className="flex-1 flex flex-col items-center gap-2 min-w-0">
            <span className="text-[10px] text-foreground-600 whitespace-nowrap">
              {t.net > 0 ? t.net : ""}
            </span>
            <div
              className={`w-full rounded-t-md transition-all ${
                i === trend.length - 1 ? "bg-accent-500" : "bg-primary-500"
              }`}
              style={{ height: `${Math.max((t.net / maxNet) * 100, t.net > 0 ? 8 : 4)}%` }}
            />
            <span className="text-[9px] text-foreground-400 truncate w-full text-center" title={t.name}>
              {t.name.length > 10 ? `${t.name.slice(0, 9)}…` : t.name}
            </span>
          </div>
        ))}
      </div>

      <p className="mt-4 text-xs text-foreground-500">
        Son netin:{" "}
        <span className="font-semibold text-accent-700">{trend[trend.length - 1].net}</span>
        {" · "}Toplam {trend.length} deneme
      </p>
    </div>
  );
}